/**
 * Единственное место, где живёт название продукта.
 *
 * Имя живёт только здесь: пакеты называются по роли (@app/backend, @app/shared), таблицы
 * и slug'и нейтральны. Не вписывайте название в разметку и строки — второй экземпляр
 * придётся искать при переименовании.
 */
export const BRAND = {
  /** Отображаемое имя в интерфейсе и текстах бота. */
  name: 'Kanvel',
  /**
   * Юзернейм бота из BotFather, без `@`. Это публичный адрес для QR-наклеек: на наклейке
   * заведения печатается `t.me/KanvelBot`, поэтому менять его после печати дорого.
   */
  botUsername: 'KanvelBot',
} as const;
